import { render, staticRenderFns } from "./AdditionalPaxInputs.vue?vue&type=template&id=c47d62d0&scoped=true&"
import script from "./AdditionalPaxInputs.vue?vue&type=script&lang=js&"
export * from "./AdditionalPaxInputs.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPaxInputs.vue?vue&type=style&index=0&id=c47d62d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47d62d0",
  null
  
)

export default component.exports